import { Phone, Mail } from "lucide-react";
import { contactInfo } from "@/data/content";

export const Footer = () => {
  return (
    <footer className="bg-[#1C1917] text-[#FDFBF7]">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/digivili-logo.png" alt="Digivili" className="h-11 w-auto" />
            <span className="font-extrabold text-2xl text-white">Digivili</span>
          </div>
          <p className="text-base leading-relaxed text-[#D6D3D1] max-w-xs">
            Henkilökohtaista ja selkokielistä digitukea – teknologia tutuksi
            helposti ja turvallisesti.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-bold text-white mb-4">Yhteystiedot</h3>
          <ul className="space-y-3">
            <li>
              <a href={contactInfo.phoneHref} className="flex items-center gap-2 text-base text-[#D6D3D1] hover:text-[#E8C88A] transition-colors">
                <Phone className="w-5 h-5" /> {contactInfo.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 text-base text-[#D6D3D1] hover:text-[#E8C88A] transition-colors">
                <Mail className="w-5 h-5" /> {contactInfo.email}
              </a>
            </li>
            <li className="text-base text-[#D6D3D1]">{contactInfo.area}</li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold text-white mb-4">Sivut</h3>
          <ul className="space-y-3 text-base text-[#D6D3D1]">
            <li><a href="#palvelut" className="hover:text-[#E8C88A] transition-colors">Palvelut</a></li>
            <li><a href="#hinnasto" className="hover:text-[#E8C88A] transition-colors">Hinnasto</a></li>
            <li><a href="#ukk" className="hover:text-[#E8C88A] transition-colors">Usein kysytyt kysymykset</a></li>
            <li><a href="#yhteys" className="hover:text-[#E8C88A] transition-colors">Ota yhteyttä</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-sm text-[#A8A29E]">
          <p>© {new Date().getFullYear()} {contactInfo.businessName}. Kaikki oikeudet pidätetään.</p>
          <p>Y-tunnus: {contactInfo.yTunnus}</p>
        </div>
      </div>
    </footer>
  );
};
